<template>
    <vx-card title="Banners">
        <div id="viewBannerLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort"
                v-model="selected" :data="banners">

                <template slot="header">
                    <div class="flex flex-wrap items-center w-full mb-2">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle"
                            @click="addBanner">Add a Banner</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th>Image</vs-th>
                    <vs-th>Url</vs-th>
                    <vs-th>Status</vs-th>
                    <vs-th>Type</vs-th>
                    <vs-th>Title</vs-th>
                    <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].image">
                            <img width="50" :src="data[indextr].image_path">
                        </vs-td>
                        <vs-td :data="data[indextr].redirect_url">
                            <feather-icon v-if="data[indextr].redirect_url" class="cursor-pointer"
                                @click="redirectToAppPath(data[indextr].redirect_url)" icon="Share2Icon"
                                svgClasses="w-10 h-10 text-primary"></feather-icon>
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip color="primary" class="product-order-status">
                                {{ data[indextr].status }}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="data[indextr].type">
                            <vs-chip v-if="data[indextr].type" color="grey" class="product-order-status">
                                {{ data[indextr].type }}
                            </vs-chip>
                        </vs-td>
                        <vs-td :data="data[indextr].title">
                            <!-- <vs-chip v-if="data[indextr].title" color="none" class="product-order-status"> -->
                            <p v-if="data[indextr].title" color="none" class="product-order-status">
                                {{ data[indextr].title }}
                            </p>
                        </vs-td>

                        <vs-td>
                            <vs-row>
                                <vs-button @click="editBanner(data[indextr])" class="mr-2" color="primary" type="border"
                                    icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deleteBanner(data[indextr])" color="danger" type="filled"
                                    icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup classContent="popup-example h-full" title="Add Banner" :active.sync="activePromptAddBanner">
                <div id="createBannerLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="addBannerForm">
                        <vs-divider position="left">Pick an image to show as banner</vs-divider>
                        <div class="vx-row mb-base">
                            <div class="vx-col w-12/12 mb-2">
                                Banner size
                                <!-- {{ isSquare }} -->
                                <vs-switch class="w-full" color="success" v-model="isSquare">

                                    <span slot="off">Square</span>
                                    <span slot="on">Rectangle</span>
                                </vs-switch>
                            </div>
                        </div>
                        <div class="vx-row mb-base">
                            <div class="vx-col w-6/12 mb-2">

                                <croppa :width="isSquare ? 500 : 260" :height="260" placeholder="Choose image"
                                    :placeholder-font-size="16" :prevent-white-space="true"
                                    v-model="myCroppa"></croppa>
                                <!-- <span class="text-danger text-sm" v-show="errors.has('addBannerForm.image')">{{
                                    errors.first('addBannerForm.image') }}</span> -->
                            </div>
                            <!-- <div class="vx-col sm:w-full mb-2">
                                <VueFileAgent name="image" ref="vueFileAgendsdt" v-validate="'required'" :theme="'list'"
                                    :multiple="false" :deletable="true" :meta="true" :compact="true" :accept="'image/*'"
                                    :maxSize="'5MB'" :helpText="'Choose Banner Image'" :errorText="{
                                        type: 'Invalid file type. Only image Allowed',
                                        size: 'Files should not exceed 5MB in size',
                                    }" @select="filesSelected($event)" @beforedelete="onBeforeDelete($event)"
                                    @delete="fileDeleted($event)" v-model="image"></VueFileAgent>
                                <span class="text-danger text-sm" v-show="errors.has('addBannerForm.image')">{{
                                    errors.first('addBannerForm.image') }}</span>
                            </div> -->
                        </div>

                        <vs-divider position="left" class="mb-0">When click on banner it will redirec to</vs-divider>

                        <div class="vx-row mb-base justify-end">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'url'" placeholder="Redirect url" name="redirect_url"
                                    v-model="create_redirect_url" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addBannerForm.redirect_url')">{{
                                    errors.first('addBannerForm.redirect_url') }}</span>
                            </div>
                        </div>

                        <!-- category select area - add cate -->
                        <vs-divider position="left"> Categories </vs-divider>

                        <div class="flex flex-wrap items-center justify-end vx-row mb-2 mb-base">
                            <div class="vx-col w-full mb-2">
                                <treeselect v-model="selected_categories" :multiple="true"
                                    :options="question_categories_options" />
                            </div>
                        </div>

                        <vs-divider position="left">This banner will show on</vs-divider>
                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-checkbox v-model="isHomePageSelected" class="">Home page</vs-checkbox>
                            </div>
                            <div class="vx-col  self-center">
                                <vs-checkbox v-model="isTheoryPageSelected" class="">Theory page</vs-checkbox>
                            </div>

                            <div class="vx-col self-center">
                                <vs-checkbox v-model="isVideosPageSelected" class="">Video page</vs-checkbox>
                            </div>
                        </div>
                        <div>
                        </div>
                        <vs-divider position="left">Banner type</vs-divider>

                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-radio class="mr-2" v-model="bannerType" vs-value="theory">Theory</vs-radio>
                            </div>
                        </div>
                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-radio class="mr-2" v-model="bannerType" vs-value="practical">Practical</vs-radio>
                                <!-- <vs-radio class="mr-2" v-model="data_local.gender" vs-value="non_binary">Non binary</vs-radio> -->
                            </div>
                        </div>
                        <div v-if="bannerType != ''" class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-button size="small" class="mr-2" @click="bannerType = '', bannerTitle = ''"
                                    vs-value="theory">Clear
                                    type</vs-button>
                            </div>
                        </div>
                        <!--  -->
                        <vs-divider v-if="bannerType != ''" position="left">Add a title for this video</vs-divider>
                        <div class="vx-row mb-4" v-if="bannerType != ''">
                            <div class="vx-col md:w-1/2 w-full">
                                <vs-input class="w-full mt-2" label="Title" v-model="bannerTitle"
                                    v-validate="'required|alpha_spaces'" name="name" />
                                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name')
                                }}</span>
                            </div>
                        </div>
                        <!--  -->
                        <vs-divider position="left">Banner status</vs-divider>
                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-switch style="width: 100px;" color="primary" icon-pack="feather"
                                    vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="create_banner">
                                    <span slot="on">Active</span>
                                    <span slot="off">Inactive</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div class="vx-col w-full mb-2">
                                <vs-button v-on:click.prevent="createBanner()" color="primary" type="filled">Save
                                    Banner</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <vs-popup classContent="popup-example h-full" title="Edit Banner" :active.sync="activePromptEditBanner">
                <div id="editBannerLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="editBannerForm">
                        <div class="vx-row mb-base">

                            <div class="vx-col w-12/12 mb-2">
                                Banner size
                                <!-- {{ isSquare }} -->
                                <vs-switch class="w-full" color="success" v-model="isSquare">

                                    <span slot="off">Square</span>
                                    <span slot="on">Rectangle</span>
                                </vs-switch>
                            </div>
                        </div>
                        <div class="vx-row mb-base">
                            <div class="vx-col w-12/12 mb-2">
                                <div class="flex items-start flex-col sm:flex-row">
                                    <img height="200px" :src="imgUrl" class="mr-8 rounded" />
                                </div>
                            </div>
                            <div class="vx-col w-12/12 mb-2">

                                <croppa :width="isSquare ? 500 : 260" :height="260" placeholder="Choose image"
                                    :placeholder-font-size="16" :prevent-white-space="true"
                                    v-model="myCroppa1"></croppa>
                            </div>

                            <!-- <div class="vx-col sm:w-full mb-2">
                                <VueFileAgent name="image" ref="vueFileAgendsdt" v-validate="''" :theme="'list'"
                                    :multiple="false" :deletable="true" :meta="true" :compact="true" :accept="'image/*'"
                                    :maxSize="'5MB'" :helpText="'Choose Banner Image'" :errorText="{
                                        type: 'Invalid file type. Only image Allowed',
                                        size: 'Files should not exceed 5MB in size',
                                    }" @select="filesSelected($event)" @beforedelete="onBeforeDelete($event)"
                                    @delete="fileDeleted($event)" v-model="image"></VueFileAgent>
                                <span class="text-danger text-sm" v-show="errors.has('editBannerForm.image')">{{
                                    errors.first('editBannerForm.image') }}</span>
                            </div> -->
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'url'" placeholder="Redirect url" name="redirect_url"
                                    v-model="update_redirect_url" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('editBannerForm.redirect_url')">{{
                                    errors.first('editBannerForm.redirect_url') }}</span>
                            </div>
                        </div>
                        <!-- category select area - edit -->
                        <vs-divider position="left"> Categories </vs-divider>

                        <div class="flex flex-wrap items-center justify-end vx-row mb-2 mb-base">
                            <div class="vx-col w-full mb-2">
                                <treeselect v-model="selected_categories" :multiple="true"
                                    :options="question_categories_options" />
                            </div>
                        </div>

                        <vs-divider position="left">This banner will show on</vs-divider>
                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-checkbox v-model="isHomePageSelected" class="">Home page</vs-checkbox>
                            </div>
                            <div class="vx-col  self-center">
                                <vs-checkbox v-model="isTheoryPageSelected" class="">Theory page</vs-checkbox>
                            </div>

                            <div class="vx-col self-center">
                                <vs-checkbox v-model="isVideosPageSelected" class="">Video page</vs-checkbox>
                            </div>
                        </div>
                        <div>
                        </div>
                        <vs-divider position="left">Banner type</vs-divider>
                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-radio class="mr-2" v-model="bannerType" vs-value="theory">Theory</vs-radio>
                            </div>
                        </div>
                        <div class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-radio class="mr-2" v-model="bannerType" vs-value="practical">Practical</vs-radio>
                                <!-- <vs-radio class="mr-2" v-model="data_local.gender" vs-value="non_binary">Non binary</vs-radio> -->
                            </div>
                        </div>


                        <div v-if="bannerType != ''" class="vx-row mb-2 mb-base">
                            <div class="vx-col  self-center">
                                <vs-button size="small" class="mr-2" @click="bannerType = '', bannerTitle = ''"
                                    vs-value="theory">Clear
                                    type</vs-button>
                            </div>
                        </div>
                        <!--  -->
                        <vs-divider v-if="bannerType != ''" position="left">Add a title for this video</vs-divider>
                        <div class="vx-row mb-4" v-if="bannerType != ''">
                            <div class="vx-col md:w-1/2 w-full">
                                <vs-input class="w-full mt-2" label="Title" v-model="bannerTitle"
                                    v-validate="'required|alpha_spaces'" name="name" />
                                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name')
                                }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-base">
                            <div class="vx-col w-full mb-2">
                                <vs-switch style="width: 100px;" color="primary" icon-pack="feather"
                                    vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="update_banner">
                                    <span slot="on">Active</span>
                                    <span slot="off">Inactive</span>
                                </vs-switch>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div class="vx-col w-full mb-2">
                                <vs-button v-on:click.prevent="updateBanner()" color="primary" type="filled">Update
                                    Banner</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <div class="vx-row mt-base">
                <div class="vx-col w-full mb-2">
                    <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'



export default {
    components: {
        vSelect,
        Treeselect,


    },
    computed: {
        question_categories_options() {
            let categories = this.$store.state.questionManagement.categories
            let categoriesData = []

            categories.forEach(function (entry, key) {
                categoriesData.push({
                    id: entry.id,
                    title: entry.name,
                    label: entry.name,
                })
            });

            return categoriesData
        },
    },
    data() {
        return {
            imgUrl: '',
            isHomePageSelected: false,
            isTheoryPageSelected: false,
            isVideosPageSelected: false,
            selected: [],
            key: null,
            active: null,
            search: null,
            totalPage: 1,
            currentPage: 1,
            banners: [],
            deleteBannerData: null,
            selected_place_name: null,
            selected_place_location: null,
            selected_place_type: "all",
            place_types: [
                { id: 'all', label: 'All' },
                { id: 'place', label: 'Banner' },
                { id: 'event', label: 'Event' },
                { id: 'tip', label: 'Tip' },
            ],
            activePromptAddBanner: false,
            activePromptEditBanner: false,
            image: [],
            fileRecordsForUpload: [],
            create_banner: true,
            update_banner: true,
            update_banner_id: null,
            create_redirect_url: null,
            update_redirect_url: null,
            selected_categories: [],
            bannerType: '',
            bannerTitle: '',
            bannerShowPages: [],
            isSquare: true,
            myCroppa: {},
            myCroppa1: {},

        }
    },
    watch: {
        isTheoryPageSelected() {
            this.checkSelectedPages('theory');
        },
        isHomePageSelected() {
            this.checkSelectedPages('home');
        },
        isVideosPageSelected() {
            this.checkSelectedPages('video');
        },
        // isHomePageSelected: false,
        //     isTheoryPageSelected: false,
        //     isVideosPageSelected: false,
        // isHomePageSelected() {
        //     this.checkSelectedPages();
        // },
        currentPage(val) {
            this.searchBanners()
            console.log(val);
        }
    },
    async mounted() {
        await this.viewBanners()
        this.banners = this.$store.state.questionManagement.banners
        await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", { avoid_paginate: "true" })
    },

    methods: {
        redirectToAppPath(path) {
            window.open(path, "_blank");
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.image.indexOf(fileRecord);
                if (k !== -1) this.image.splice(k, 1);
            } else {
                this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        addBanner() {
            this.create_redirect_url = null;
            this.activePromptAddBanner = true;
        },
        createBanner() {
            this.$validator.validateAll('addBannerForm').then(result => {
                if (result) this.createBannerApi()
            })
        },
        async createBannerApi() {

            var self = this
            // this.$vs.loading({
            //     container: '#createBannerLoadingDiv',
            //     scale: 0.6
            // })
            let data = new FormData();
            data.append('id', this.update_banner_id);


            data.append('redirect_url', this.update_redirect_url);
            data.append('status', this.update_banner ? "active" : "inactive");

            // add myCroppa image
            const blob = await this.myCroppa.promisedBlob()
            console.log(blob);
            // if (this.myCroppa.hasImage())
             data.append('image', blob);

            data.append('redirect_url', this.create_redirect_url);
            data.append('status', this.create_banner ? "active" : "inactive");
            // if (this.image.length) data.append('image', this.image[0].file);

            // check categories
            if (this.selected_categories != null) {
                for (let i = 0; i < this.selected_categories.length; i++) {
                    data.append('categories[]', this.selected_categories[i]);
                }
            }
            // type

            data.append('type', this.bannerType);
            // title
            data.append('title', this.bannerTitle);
            var pages = this.checkSelectedPages();
            if (pages.length) {
                for (let i = 0; i < pages.length; i++) {
                    if (pages[i] != undefined) {

                        data.append('page', pages[i]);
                    }
                    // data.append('page[]', pages[i]);
                }
            }




            for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            console.log(data);

            this.$store.dispatch("questionManagement/createBanner", data)
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close('#createBannerLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Banner created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.activePromptAddBanner = false;

                    this.ima

                })
                .catch(err => {
                    this.$vs.loading.close('#createBannerLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function (key) {
                        self.errors.add({
                            field: key,
                            scope: "addBannerForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        checkSelectedPages(val) {
            // if (this.bannerShowPages.includes(val)) {
            //     console.log('already added!');

            // } else {
            //     this.bannerShowPages.push(val);
            // }
            // console.log(this.bannerShowPages);
            // // var pageArr = [this.isHomePageSelected, this.isTheoryPageSelected, this.isVideosPageSelected]

            if (this.bannerShowPages.includes(val)) {

                this.bannerShowPages.splice(this.bannerShowPages.indexOf(val), 1);

            } else {
                this.bannerShowPages.push(val);
            }
            // if (this.isTheoryPageSelected) {
            //     this.bannerShowPages.push('theory');
            // }
            // else {
            //     this.bannerShowPages.splice(this.bannerShowPages.indexOf('theory'), 1);
            // }
            // if (this.isTheoryPageSelected) {
            //     this.bannerShowPages.push('video');
            // } else {
            //     this.bannerShowPages.splice(this.bannerShowPages.indexOf('video'), 1);
            // }

            // }
            // console.log(this.bannerShowPages);
            // this.bannerShowPages = [...new Set(this.bannerShowPages)];
            return this.bannerShowPages;
            console.log(this.bannerShowPages);
        },
        editBanner(banner) {
            console.log(banner);
            this.bannerType = banner.type
            this.bannerTitle = banner.title;
            this.update_redirect_url = banner.redirect_url;
            this.update_banner_id = banner.id;
            this.update_banner = banner.status == "active" ? true : false;
            this.image = [];
            this.imgUrl = banner.image_path,
                this.activePromptEditBanner = true
            this.selected_categories = JSON.parse(banner.category_ids);


            if (banner.page == 'all' || banner.page == 'null') {
                this.isHomePageSelected = false;
                this.isTheoryPageSelected = false;
                this.isVideosPageSelected = false;

            } else {
                // var dd = JSON.parse(banner.page);
                // console.log(dd);
                // console.log(JSON.parse(banner.page).includes('home'));
                // console.log(JSON.parse(banner.page).includes('video'));
                // console.log(JSON.parse(banner.page).includes('theory'));
                if (JSON.parse(banner.page).includes('home')) {
                    this.isHomePageSelected = true;
                } else {
                    this.isHomePageSelected = false;
                }
                if (JSON.parse(banner.page).includes('video')) {
                    this.isVideosPageSelected = true;
                } else {
                    this.isVideosPageSelected = false;
                }
                if (JSON.parse(banner.page).includes('theory')) {
                    this.isTheoryPageSelected = true;
                } else {
                    this.isTheoryPageSelected = false;
                }


            }



        },
        updateBanner() {


            this.$validator.validateAll('editBannerForm').then(result => {

                if (result) this.updateBannerApi()
            })
        },

        async updateBannerApi() {
            var self = this
            // this.$vs.loading({
            //     container: '#editBannerLoadingDiv',
            //     scale: 0.6
            // })

            let data = new FormData();
            data.append('id', this.update_banner_id);
            data.append('redirect_url', this.update_redirect_url);
            data.append('status', this.update_banner ? "active" : "inactive");

            const blob = await this.myCroppa1.promisedBlob()
            if (this.myCroppa1.hasImage()) data.append('image', blob);
            console.log(blob);


            // // if (this.image.length) data.append('image', this.image[0].file);

            // check categories
            if (this.selected_categories != null) {
                for (let i = 0; i < this.selected_categories.length; i++) {
                    data.append('categories[]', this.selected_categories[i]);
                }
            }
            // type
            data.append('type', this.bannerType);
            data.append('title', this.bannerTitle);
            var pages = this.checkSelectedPages();
            // console.log('page:');
            // console.log(pages);

            if (pages != null) {
                for (let i = 0; i < pages.length; i++) {
                    // console.log(pages[i])

                    if (pages[i] != undefined) {

                        data.append('page', pages[i]);
                    }

                }
            }
            // console.log('ím pages');
            // console.log(pages);
            // console.log('ím pages');
            data.append('page', pages)




            for (var pair of data.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }
            // console.log(data);

            this.$store.dispatch("questionManagement/updateBanner", data)
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close('#editBannerLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Banner updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.update_banner_id = null;
                    this.activePromptEditBanner = false;

                })
                .catch(err => {
                    this.$vs.loading.close('#editBannerLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function (key) {
                        self.errors.add({
                            field: key,
                            scope: "editBannerForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteBanner(place) {
            this.deleteBannerData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this data ?',
                accept: this.acceptDeleteBanner
            })
        },
        acceptDeleteBanner() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteBanner", { id: this.deleteBannerData.id })
                .then(res => {
                    console.log(res);
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Banner deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.$vs.loading.close()
                })
        },


        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchBanners()
            }, 2000);
        },
        handleChangePage(page) {
            console.log(page);
            // this.searchUser()
        },
        handleSort(key, active) {
            if (key) {
                this.key = key
                this.active = active
                this.searchBanners()
            }
        },
        async searchBanners() {
            var self = this
            console.log(self);
            this.$vs.loading({
                container: '#viewBannerLoadingDiv',
                scale: 0.6
            })

            let data = {
                name: this.selected_place_name,
                location: this.selected_place_location,
                sort: this.key,
                sort_key: this.active,
                page: this.currentPage,
                place_type: this.selected_place_type,
            }

            await this.$store.dispatch("questionManagement/viewBanner", data)
                .then(res => {
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewBannerLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    console.log(err);
                    this.$vs.loading.close('#viewBannerLoadingDiv > .con-vs-loading')
                })

            this.banners = this.$store.state.questionManagement.banners
        },
        async viewBanners() {
            var self = this
            this.$vs.loading();
            console.log(self);
            await this.$store.dispatch("questionManagement/viewBanner", { page: this.currentPage })
                .then(res => {
                    this.totalPage = res.data.last_page
                })

            this.banners = this.$store.state.questionManagement.banners
            this.$vs.loading.close()

        },
    },
    async created() {
        if (!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }


    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.vs-con-textarea {
    height: 400px;
}

.vs-textarea {
    height: 100%;
}
</style>

